export default "__VITE_ASSET__mT4Uk3Df__"